import {GameStrategy} from '../base/GameStrategy';
import {StaticData} from '../../../data/StaticData';
import {GameScene} from '../../../pixi_scene/GameScene';
import {TableController} from '../../../controllers/silent/TableController';
import {Stack} from '../../../pixi_scene/game_scene/game_table/table_objects/stacks/Stack';
import {HandEvents} from '../../../pixi_scene/game_scene/hand/HandEvents';

export class DetectiveClubPlayerStrategy extends GameStrategy
{
    static stacks: Stack[] | undefined;
    private static gameState: any;

    static handReset(): void {
        GameScene.hand.interactive = GameScene.hand.interactiveChildren = true;
        GameScene.hand.alpha = 1;
    }

    private static onHandUpdated(): void {
        let myTurn: boolean = DetectiveClubPlayerStrategy.gameState?.automation?.playersMap?.[StaticData.playerId]?.master;
        if (myTurn && !DetectiveClubPlayerStrategy.nextSpeakerButtonVisible()) {
            DetectiveClubPlayerStrategy.handReset();
        } else {
            GameScene.hand.interactive = GameScene.hand.interactiveChildren = false;
            GameScene.hand.alpha = .5;
        }
    }

    private static nextSpeakerButtonVisible(): boolean {
        const button = this.gameState.zones.chat.buttons.detective_club?.nextSpeaker;
        if (!button || !button.enabled) {
            return false;
        }
        if (button.visibleFor.length) {
            return button.visibleFor.includes(StaticData.playerId);
        }
        return true;
    }

    private static removeListener(): void {
        removeEventListener(HandEvents.UPDATED, DetectiveClubPlayerStrategy.onHandUpdated);
    }

    isApplicable(gameState: any): boolean {
        let detectiveClubGame: boolean = gameState?.tasks?.state?.activity?.name == 'Detective Club';
        console.warn('DK PLayer Strategy aplicable:', detectiveClubGame);
        return detectiveClubGame;
    }

    disable(): void {
        if(!this.running){
            return;
        }
        DetectiveClubPlayerStrategy.removeListener();
        DetectiveClubPlayerStrategy.handReset();
        super.disable();
    }

    execute(gameState: any): void {
        super.execute(gameState);
        DetectiveClubPlayerStrategy.gameState = gameState;
        DetectiveClubPlayerStrategy.stacks = TableController.table.tableObjects!.stacks.stacks;
        console.warn('DK PLayer Strategy execute');

        addEventListener(HandEvents.UPDATED, DetectiveClubPlayerStrategy.onHandUpdated);
        DetectiveClubPlayerStrategy.onHandUpdated();
    }
}
